import { usageIds } from "../../../../constants/usageid.js";
export var DataTableConfigurationSchemaIds;
(function (DataTableConfigurationSchemaIds) {
    DataTableConfigurationSchemaIds["DATA_TABLE_CONFIGURATION"] = "data-tbl-config";
})(DataTableConfigurationSchemaIds || (DataTableConfigurationSchemaIds = {}));
export var DataTableConfigurationTags;
(function (DataTableConfigurationTags) {
    DataTableConfigurationTags["DEFAULT"] = "default";
})(DataTableConfigurationTags || (DataTableConfigurationTags = {}));
export const DataTableConfigurationTagsMap = {
    [DataTableConfigurationSchemaIds.DATA_TABLE_CONFIGURATION]: [
        DataTableConfigurationTags.DEFAULT
    ]
};
export const DataTableConfigurationUsageIds = usageIds(DataTableConfigurationTagsMap);
